module.exports = __webpack_public_path__ + "img/16.0882987e.webp";